import { Component, OnInit } from '@angular/core';
import { InternalAppInitialisationService } from '@internal-services/app-initialisation.service';
import { INavigationRoute } from '@shared-libs/interfaces';
import { ValidationService } from '@shared-services/validation.service';
import { getDesktopInternalNavigationRoutes, getMobileInternalNavigationRoutes } from './internal.navigation';
import { UserManager } from '@shared-managers/user.manager';

@Component({
	selector: 'internal-component',
	templateUrl: 'internal.component.html',
})
export class InternalComponent implements OnInit {
	public routes: Array<INavigationRoute>;
	public profilePicture: string;
	public username: string;

	constructor(
		public readonly validationService: ValidationService,
		private readonly appInitialisationService: InternalAppInitialisationService,
		private readonly userManager: UserManager
	) {
		void this.appInitialisationService.initialize().catch();
	}

	public ngOnInit(): void {
		if (this.validationService.isOnMobileTemplate()) {
			this.userManager.getUserPermissionsSubject().subscribe(() => {
				this.routes = getMobileInternalNavigationRoutes();
			});
		} else {
			this.userManager.getUserPermissionsSubject().subscribe(() => {
				this.routes = getDesktopInternalNavigationRoutes();
			});
		}
	}
}
